import update from 'immutability-helper';
import PDFPageEditorEnum from './PDFPageEditorConstants';

const initialState = {
  pages: [],
  initialFile: [],
  activeThumbnailIndex: 0,
  documentReadyState: 'loading',
  isPDFEdited: false,
};

const PDFPageEditorReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case PDFPageEditorEnum.PDF_PAGE_EDITOR_SET_DOCUMENT_READY_STATE:
      return update(state, {
        documentReadyState: { $set: action.documentReadyState },
      });
    case PDFPageEditorEnum.PDF_PAGE_EDITOR_SET_ACTIVE_THUMBNAIL_INDEX:
      return update(state, {
        activeThumbnailIndex: { $set: action.activeThumbnailIndex },
      });
    case PDFPageEditorEnum.PDF_PAGE_EDITOR_ADD_BLANK_PAGE:
      return update(state, {
        pages: { $splice: [[action.blankPageIndex, 0, action.blankPage]] },
      });
    case PDFPageEditorEnum.PDF_PAGE_EDITOR_DELETE_PAGE:
      return update(state, {
        pages: { $splice: [[action.pageIndex, 1]] },
      });
    case PDFPageEditorEnum.PDF_PAGE_EDITOR_SET_PAGES:
      return update(state, {
        pages: { $set: action.pages },
      });
    case PDFPageEditorEnum.PDF_PAGE_EDITOR_SET_PAGES_FROM_FILE:
      return update(state, {
        pages: { $unshift: action.pages },
      });
    case PDFPageEditorEnum.PDF_PAGE_EDITOR_SET_EDIT_STATE_TO_TRUE:
      return update(state, {
        isPDFEdited: { $set: true },
      });
    default:
      return state;
  }
};

export default PDFPageEditorReducer;



// WEBPACK FOOTER //
// ./src-react/PDFPageEditor/PDFPageEditorReducer.jsx